export default __webpack_public_path__ + "static/media/034-rubber duck.6db1e238.svg";